// extracted by mini-css-extract-plugin
export var actionIcon = "_uu-0";